import { restApiUrl, headers as authHeaders } from '../pages/app_props'

const BASE = restApiUrl || '';

function buildUrl(path) {
    if (!path) return BASE
    if (path.startsWith('http')) return path
    if (BASE.endsWith('/') && path.startsWith('/')) return BASE + path.substring(1)
    if (!BASE.endsWith('/') && !path.startsWith('/')) return BASE + '/' + path
    return BASE + path
}

async function request(path, options = {}) {
    const url = buildUrl(path)
    const hdrs = authHeaders ? authHeaders() : new Headers()
    // merge provided headers
    if (options.headers) {
        Object.entries(options.headers).forEach(([k, v]) => hdrs.set(k, v))
    }

    const fetchOpts = { ...options, headers: hdrs }
    const resp = await fetch(url, fetchOpts)
    if (!resp.ok) {
        const text = await resp.text();
        throw new Error(text || resp.statusText);
    }
    // attempt parse JSON, otherwise return text
    const ct = resp.headers.get('content-type') || '';
    if (ct.indexOf('application/json') !== -1) return resp.json();
    return resp.text();
}

export function apiGet(path) {
    return request(path, { method: 'GET' });
}

export function apiPost(path, body) {
    return request(path, { method: 'POST', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } });
}

export function apiPut(path, body) {
    return request(path, { method: 'PUT', body: JSON.stringify(body), headers: { 'Content-Type': 'application/json' } });
}

export function apiDelete(path) {
    return request(path, { method: 'DELETE' });
}

export default { apiGet, apiPost, apiPut, apiDelete };
